@if (!hasImage(contentBlock.imageBlock)) {
  <svg class="img-placeholder" xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100" enable-background="new 0 0 100 100">
    <path fill="#B2B3B3"
      d="M17.8 82.2v-64.4h64.4v64.4h-64.4zm63.3-17.2v2.1h-62.2v-2.1h62.2zm-1 15.1v-60.2h-60.2v60.2h60.2zm-13.5-33.8c-.3-.6-.8-1.1-1.3-1.4-.5-.4-1.2-.5-1.9-.5-.6 0-1.2.1-1.7.4-.5.3-.9.7-1.2 1.3l-8.2 14c-.1.2-.2.3-.4.4-.2.1-.3.2-.5.2s-.3 0-.5-.1-.3-.2-.4-.4c-.1-.1-1.2-1.3-3.4-3.9-2.2-2.5-4.9-3.8-7.9-3.8-1.2 0-2.5.5-3.7 1.6-1.3 1.1-2.5 2.4-3.5 3.9-1.1 1.5-2 3.1-2.8 4.7-.8 1.6-1.4 2.9-1.8 3.9l-2-.8c.2-.4.6-1.4 1.4-3 .8-1.7 1.8-3.4 3-5.2 1.2-1.8 2.6-3.5 4.2-5s3.3-2.2 5.2-2.2c2.8 0 5.2.9 7.4 2.7 2.1 1.8 3.7 3.3 4.7 4.6l7.3-12.7c.5-.9 1.2-1.6 2-2.1.9-.5 1.8-.8 2.8-.8 1.1 0 2.1.3 3 .9.9.6 1.6 1.3 2.1 2.3l10.4 20.3-1.9 1-10.4-20.3zm-35.2-6.3c-.9-1-1.4-2.2-1.4-3.6s.5-2.6 1.5-3.6 2.2-1.5 3.6-1.5h.6c.5-1.6 1.4-2.9 2.8-3.9s2.9-1.5 4.7-1.5c2.2 0 4 .8 5.5 2.3 1.5 1.5 2.3 3.4 2.3 5.5 0 1-.2 2-.6 2.9-.4.9-.9 1.8-1.6 2.5-.7.7-1.5 1.2-2.4 1.6-.9.4-1.9.6-2.8.6h-8.799999999999999c-1.4.1-2.5-.4-3.4-1.3zm1.6-5.7c-.6.6-.9 1.3-.9 2.1s.3 1.5.9 2.1c.6.6 1.3.8 2.1.8h8.599999999999998c.7 0 1.4-.1 2-.4.7-.3 1.2-.7 1.7-1.2s.9-1.1 1.2-1.7c.3-.7.4-1.4.4-2.2 0-1.6-.6-2.9-1.7-4s-2.5-1.7-4-1.7c-1.4 0-2.6.4-3.7 1.3s-1.7 2-1.9 3.5l-.2 1.3-1.2-.5c-.2-.1-.3-.1-.5-.1h-.5c-1-.1-1.7.2-2.3.7z" />
  </svg>
}
@if (hasImage(contentBlock.imageBlock)) {
  <p id="image-container-{{contentBlock.imageBlock.id}}">
    <a id="content-image-{{contentBlock.imageBlock.id}}" href="javascript:void(0)">
      <!-- images with hotspot -->
      @if (contentBlock.imageBlock.hotspotHtmlString != null && contentBlock.imageBlock.hotspotHtmlString.length > 0) {
        <div class="map-area-container" id="imgCont-{{contentBlock.imageBlock.id}}"
          >
          <div appHotspotViewer [playbookId]="contentBlock.playbookId" [imgBlock]="contentBlock.imageBlock" [clickRedirection]="false"
            class="litetooltip-hotspot-wrapper">
            <div class="litetooltip-hotspot-container" id="hp-container-{{contentBlock.imageBlock.id}}">
              <img
                [ngStyle]="contentBlock.imageBlock.enableImageAction == true && {'cursor':'pointer'} || {'cursor':'default'}"
                class="content-block-content content-block-image-image" [src]="getPlaceHolder()" alt=""
                [hidden]="imageLoaded" />
              <div id="outer-box">
                <img #contentImage
                  [ngStyle]="contentBlock.imageBlock.enableImageAction == true && {'cursor':'pointer'} || {'cursor':'default'}"
                  class="content-block-content content-block-image-image"
                  [src]="getImageUrl(contentBlock.imageBlock) | loadSecureAssets : true | async"
                  onerror="this.src = '/assets/img/loader.gif'" alt=""
                  [attr.loading]="disableLazyLoad ? null : 'lazy'"
                  id="image-{{contentBlock.imageBlock.id}}" (load)="imageLoaded = true;setHotspotImageStyle(contentBlock.imageBlock.id)" [hidden]="!imageLoaded" />
              </div>
            </div>
          </div>
          <div id="map-area-viewer">
          </div>
        </div>
      }
      <!-- images without hotspot -->
      @if (contentBlock.imageBlock.hotspotHtmlString == null || contentBlock.imageBlock.hotspotHtmlString == '') {
        <div>
          <img [ngStyle]="contentBlock.imageBlock.enableImageAction == true && {'cursor':'pointer'} || {'cursor':'default'}"
            class="content-block-content content-block-image-image" [src]="getPlaceHolder()" alt="" [hidden]="imageLoaded" />
          <div id="outer-box">
            <img #contentImage
              [ngStyle]="contentBlock.imageBlock.enableImageAction == true && {'cursor':'pointer'} || {'cursor':'default'}"
              class="content-block-content content-block-image-image"
              [src]="getImageUrl(contentBlock.imageBlock) | loadSecureAssets : true | async" onerror="this.src = '/assets/img/loader.gif'"
              alt="" [attr.loading]="disableLazyLoad ? null : 'lazy'" id="image-{{contentBlock.imageBlock.id}}" (load)="imageLoaded = true"
              [hidden]="!imageLoaded" />
          </div>
        </div>
      }
    </a>
  </p>
}
